<script setup lang="ts">

import {computed, Comment, type VNode, type PropType} from "vue";
import {isNonEmptyString} from "../js-utils";

const slots = defineSlots<{
  default(props: {}): any
}>()

const props = defineProps({
  type: {type: String, default: "danger"},
  dismissable: {type: Boolean, default: true},
  message: {type: String as PropType<string | null>},
  detailsHTML: {type: String},
  additionalCssClass: {type: String, default: ""},
})

const alertClass = computed((): string => {
  let dismissibleClass = ''
  if (props.dismissable) {
    dismissibleClass = 'alert-dismissible'
  }
  return `alert alert-sm alert-${props.type} ${dismissibleClass} fade show ${props.additionalCssClass}`
})

const showAlert = computed((): boolean => isNonEmptyString(props.message))

const vnodeHasContent = (vnodes: VNode | VNode[] | undefined | null): boolean => {
  // https://github.com/vuejs/core/issues/4733#issuecomment-933284261
  return (
    !!vnodes &&
    (Array.isArray(vnodes)
      ? vnodes.every(vnode => vnode.type !== Comment)
      : vnodes.type !== Comment)
  )
}

const defaultSlotHasContent = (): boolean => {
  if (typeof slots.default === 'function') {
    const vnodes = slots.default({})
    return vnodeHasContent(vnodes)
  }

  return false
}

const showDetails = computed((): boolean => {
  return isNonEmptyString(props.detailsHTML) || defaultSlotHasContent()
})

defineEmits<{
  (e: 'dismiss'): void
}>()

</script>

<template>
  <div
    v-if="showAlert"
    :class="alertClass"
    role="alert"
  >
    {{ message }}
    <button
      v-if="dismissable"
      type="button"
      class="btn-close"
      aria-label="Close"
      @click.prevent="$emit('dismiss')"
    />
    <template v-if="showDetails">
      <hr>
      <div v-html="detailsHTML" />
      <slot />
    </template>
  </div>
</template>
